module.exports = __webpack_public_path__ + "media/promo/hochland/images/snow2-c0b6c190c5fd324e987d3e0625634949.png";